import { render, staticRenderFns } from "./BlocksTransactionsRow.vue?vue&type=template&id=6832b4f8&scoped=true"
import script from "./BlocksTransactionsRow.vue?vue&type=script&lang=js"
export * from "./BlocksTransactionsRow.vue?vue&type=script&lang=js"
import style0 from "./BlocksTransactionsRow.vue?vue&type=style&index=0&id=6832b4f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6832b4f8",
  null
  
)

export default component.exports